import { Box, Flex, Text, Tabs, Blockquote, AspectRatio, Inset } from "@radix-ui/themes";

export default function TransversalEcoBanner() {
  return (
    <>
    <div className="container py-3">
      <div className='row'>
        <div className='col-lg-4'>
          <div className="container">

            <div className='row py-3'>
              <div className='col'>
                <Inset clip="padding-box" side="top" pb="current">
                  <img
                    src="https://www.shadvala.org/img/interstices-transversality.jpg"
                    alt="Transversality"
                    style={{
                      display: 'block',
                      objectFit: 'cover',
                      width: '40%',
                      height: '40%',
                      backgroundColor: 'var(--gray-5)',
                    }}
                  />
                </Inset>
              </div>
            </div>

            <div className='row pb-1'>
              <div className='col'>
                <Blockquote size="6" weight="bold" color>
                  Transversality
                </Blockquote>
              </div>
            </div>

            <div className='row py-3 border-bottom'>
              <div className='col'>
                <Text size="3" color> 
                  A modality of thinking that establishes connections and bridges (instead of delimitations) between different disciplines of knowledge (within Western culture) and ways of configuring the world (within and outside the parameters of mainstream Western culture). Transversal thinking cuts across the disciplines to gather different elements and bring them to a new form of synthesis. It interacts not only with discourses produced by the dominant epistemic institutions in the West but also with practices stemming from radically different world-configurations, and it brings seemingly incommensurable points of view together in an unprecedented dialogical confrontation.
                </Text>
              </div>
            </div>
          </div>
        </div>

        <div className='col-lg-4'>
          <div className="container">

            <div className='row py-3'>
              <div className='col'>
                <Inset clip="padding-box" side="top" pb="current">
                  <img
                    src="https://www.shadvala.org/img/interstices-ecosophy.jpg"
                    alt="Ecosophy"
                    style={{
                      display: 'block',
                      objectFit: 'cover',
                      width: '35%',
                      height: '35%',
                      backgroundColor: 'var(--gray-5)',
                    }}
                  />
                </Inset>
              </div>
            </div>

            <div className='row pb-1'>
              <div className='col'>
                <Blockquote size="6" weight="bold" color>
                  Ecosophy
                </Blockquote>
              </div>
            </div>

            <div className='row py-3 border-bottom'>
              <div className='col'>
                <Text size="3" color> 
                  A philosophy of life which considerably differs from the ‘science’ and the ‘politics’ of ‘ecology’. While ecology is centered on reforms that might render natural resources sustainable and protect the environment from destructive anthropization, ecosophy aims at recapturing a form of ‘wisdom’ that implies decentering human beings from the uppermost place in the so-called ‘hierarchy of creation’, becoming aware of our concrete embeddedness in a network of essentially interrelated human and non-human beings, and creating a different way of being-in-the-world with the aid of other (non-European) cultures whose relationship with non-human agency has not been destructive.
                </Text>
              </div>
            </div>
          </div>
        </div>
        
        <div className='col-lg-4'>
          <div className="container">

            <div className='row py-3'>
              <div className='col'>
                <Inset clip="padding-box" side="top" pb="current">
                  <img
                    src="https://www.shadvala.org/img/interstices-transculturality.jpg"
                    alt="Transculturality"
                    style={{
                      display: 'block',
                      objectFit: 'cover',
                      width: '28%',
                      height: '28%',
                      backgroundColor: 'var(--gray-5)',
                    }}
                  />
                </Inset>
              </div>
            </div>

            <div className='row pb-1'>
              <div className='col'>
                <Blockquote size="6" weight="bold" color>
                  Transculturality
                </Blockquote>
              </div>
            </div>
            <div className='row py-3 border-bottom'>
              <div className='col'>
                <Text size="3" color> 
                  A process in which we go beyond the framework of our own (dominant) world-configuration and its mechanisms of appropriation in order to understand, respect, and support other cultures’ ways of being. The exercise of transculturality consists in participating in the world-configuration of the other, thus gaining concrete insights into other modalities of being-in-the-world. This process is not merely intellectual. It implies going beyond oneself, abandoning one’s own comfort zone, questioning one’s own constitutive and regulative prejudices in a relational exercise of self- analysis and self-critique, gaining a broader understanding of the other and therefore of ourselves.
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>        
    </>
  )
}
